import React from "react";
import "./Mitgliedschaft.css";

export default function Mitgliedschaft() {
  return (
    <main className="mitgliedschaft-container">
      <h1>Mitgliedschaft bei DiverDuck Berlin e.V.</h1>

      <section className="mitgliedschaft-section">
        <h2>Aufnahmegebühr</h2>
        <p>Für neue Mitglieder wird eine einmalige Aufnahmegebühr erhoben:</p>
        <ul>
          <li>
            <strong>65 €</strong> für Berufstätige
          </li>
          <li>
            <strong>40 €</strong> für Minderjährige, Auszubildende & Studierende
          </li>
        </ul>
      </section>

      <section className="mitgliedschaft-section">
        <h2>Mitgliedsbeitrag</h2>
        <p>
          Die Mitgliedsbeiträge sind gestaffelt und jährlich zum{" "}
          <strong>1. Januar</strong> fällig:
        </p>
        <ul>
          <li>
            <strong>156 €</strong> für berufstätige Taucher:innen
          </li>
          <li>
            <strong>96 €</strong> für berufstätige Schwimmer:innen, tauchende
            Azubis & Studierende
          </li>
          <li>
            <strong>72 €</strong> für minderjährige oder passive Mitglieder
          </li>
          <li>
            <strong>340 €</strong> für Familienmitgliedschaften
          </li>
        </ul>
        <p>
          Bei Eintritt während des Jahres wird der Beitrag anteilig für aktive
          Monate berechnet. Bleibt die Zahlung bis <strong>Ende März</strong>{" "}
          aus, kann ein Ausschluss vom Training erfolgen.
        </p>
      </section>

      <section className="mitgliedschaft-section">
        <h2>Änderung der Mitgliedschaft</h2>
        <p>
          Änderungen der Mitgliedschaft sind immer zum{" "}
          <strong>nächsten Kalenderjahr</strong> möglich.
        </p>
        <p>
          ➤{" "}
          <a
            href="/pdfs/Beitrittserklaerung.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Aufnahmeantrag / Änderungsantrag (PDF)
          </a>
        </p>
      </section>

      <section className="mitgliedschaft-section">
        <h2>Kündigung</h2>
        <p>
          Die Kündigung ist zum <strong>Jahresende</strong> möglich. Die
          schriftliche Austrittserklärung muss bis spätestens{" "}
          <strong>30. September</strong> per Post oder E-Mail beim Vorstand
          eingehen.
        </p>
        <p>
          Bereits gezahlte Beiträge werden <strong>nicht erstattet</strong>.
          Ausstehende Beiträge bleiben zahlungspflichtig.
        </p>
      </section>
    </main>
  );
}
